import { render, staticRenderFns } from "./RobberyProtectionMeansQuestion.vue?vue&type=template&id=f28c16ea&scoped=true"
import script from "./RobberyProtectionMeansQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyProtectionMeansQuestion.vue?vue&type=script&lang=ts"
import style0 from "./RobberyProtectionMeansQuestion.vue?vue&type=style&index=0&id=f28c16ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28c16ea",
  null
  
)

export default component.exports